module.exports = function (data) {
    return {
        event: 'BWSAUproductsInSameOfferView',
        eventContext: {
            area: 'product page',
            productGroup: {
                name: data.productGroupName,
                id: data.productGroupId
            }
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/detail/relatedproducts/atmmapper/related-products-view-mapper.js
 **/